import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialMollieReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const mollieSlice = createSlice({
    name: "Mollie",
    initialState: { ...initialMollieReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default mollieSlice;
